export default async ({ form, onSubmit }) => onSubmit(form.getValues());
